export function countLines(text: string): number {
    return text.split('\n').length;
}

export function attachLineNumbers(textarea: HTMLTextAreaElement, gutter: HTMLDivElement): void {
    const render = (): void => {
        const n = countLines(textarea.value);
        gutter.innerHTML = Array.from({ length: n }, (_, i) => i + 1).join('<br>');
    };
    textarea.addEventListener('input', render);
    textarea.addEventListener('scroll', () => {
        gutter.scrollTop = textarea.scrollTop;
    });
    render();
}

// ponytail: counts logical `\n` lines, not soft-wrapped visible lines — numbers drift on wrap. Upgrade path: a per-line height measurement editor (CodeMirror) when wrapping matters.
